/**
 * If you make changes to this file, you must also update any select
 * dropdowns in Zuddl which contain a copy of these options.
 */
export const countriesData = [
  {
    label: 'Afghanistan',
    value: 'Afghanistan',
    timezones: ['Asia/Kabul'],
  },
  {
    label: 'Africa (Region)',
    value: 'Africa (Region)',
    timezones: [
      'Africa/Abidjan',
      'Africa/Accra',
      'Africa/Addis_Ababa',
      'Africa/Asmara',
      'Africa/Bamako',
      'Africa/Bangui',
      'Africa/Banjul',
      'Africa/Bissau',
      'Africa/Blantyre',
      'Africa/Brazzaville',
      'Africa/Bujumbura',
      'Africa/Conakry',
      'Africa/Dakar',
      'Africa/Dar_es_Salaam',
      'Africa/Djibouti',
      'Africa/Douala',
      'Africa/Freetown',
      'Africa/Harare',
      'Africa/Juba',
      'Africa/Khartoum',
      'Africa/Kinshasa',
      'Africa/Libreville',
      'Africa/Lome',
      'Africa/Luanda',
      'Africa/Lubumbashi',
      'Africa/Malabo',
      'Africa/Maputo',
      'Africa/Maseru',
      'Africa/Mbabane',
      'Africa/Mogadishu',
      'Africa/Monrovia',
      'Africa/Ndjamena',
      'Africa/Niamey',
      'Africa/Nouakchott',
      'Africa/Ouagadougou',
      'Africa/Porto-Novo',
      'Africa/Sao_Tome',
      'Africa/Tripoli',
      'Africa/Windhoek',
      'Atlantic/Cape_Verde', // Cape Verde sits in the Atlantic/* prefix despite being part of Africa
    ],
  },
  {
    label: 'Algeria',
    value: 'Algeria',
    timezones: ['Africa/Algiers'],
  },
  {
    label: 'Antigua and Barbuda',
    value: 'Antigua and Barbuda',
    timezones: ['America/Antigua'],
  },
  {
    label: 'Argentina',
    value: 'Argentina',
    timezones: [
      'America/Argentina/Buenos_Aires',
      'America/Argentina/Catamarca',
      'America/Argentina/Cordoba',
      'America/Argentina/Jujuy',
      'America/Argentina/La_Rioja',
      'America/Argentina/Mendoza',
      'America/Argentina/Rio_Gallegos',
      'America/Argentina/Salta',
      'America/Argentina/San_Juan',
      'America/Argentina/San_Luis',
      'America/Argentina/Tucuman',
      'America/Argentina/Ushuaia',
    ],
  },
  {
    label: 'Armenia',
    value: 'Armenia',
    timezones: ['Asia/Yerevan'],
  },
  {
    label: 'Asia (Region)',
    value: 'Asia (Region)',
    timezones: [
      'Asia/Baghdad',
      'Asia/Damascus',
      'Asia/Pyongyang',
      'Asia/Tehran',
    ],
  },
  {
    label: 'Australia',
    value: 'Australia',
    requiresConsent: true,
    timezones: [
      'Antarctica/Macquarie',
      'Australia/Adelaide',
      'Australia/Brisbane',
      'Australia/Broken_Hill',
      'Australia/Darwin',
      'Australia/Eucla',
      'Australia/Hobart',
      'Australia/Lindeman',
      'Australia/Lord_Howe',
      'Australia/Melbourne',
      'Australia/Perth',
      'Australia/Sydney',
    ],
  },
  {
    label: 'Austria',
    value: 'Austria',
    requiresConsent: true,
    timezones: ['Europe/Vienna'],
  },
  {
    label: 'Azerbaijan',
    value: 'Azerbaijan',
    timezones: ['Asia/Baku'],
  },
  {
    label: 'Bahamas',
    value: 'Bahamas',
    timezones: ['America/Nassau'],
  },
  {
    label: 'Bahrain',
    value: 'Bahrain',
    timezones: ['Asia/Bahrain'],
  },
  {
    label: 'Bangladesh',
    value: 'Bangladesh',
    timezones: ['Asia/Dhaka'],
  },
  {
    label: 'Barbados',
    value: 'Barbados',
    timezones: ['America/Barbados'],
  },
  {
    label: 'Belgium',
    value: 'Belgium',
    requiresConsent: true,
    timezones: ['Europe/Brussels'],
  },
  {
    label: 'Belize',
    value: 'Belize',
    timezones: ['America/Belize'],
  },
  {
    label: 'Bhutan',
    value: 'Bhutan',
    timezones: ['Asia/Thimphu'],
  },
  {
    label: 'Bolivia',
    value: 'Bolivia',
    timezones: ['America/La_Paz'],
  },
  {
    label: 'Botswana',
    value: 'Botswana',
    timezones: ['Africa/Gaborone'],
  },
  {
    label: 'Brazil',
    value: 'Brazil',
    timezones: [
      'America/Araguaina',
      'America/Bahia',
      'America/Belem',
      'America/Boa_Vista',
      'America/Campo_Grande',
      'America/Cuiaba',
      'America/Eirunepe',
      'America/Fortaleza',
      'America/Maceio',
      'America/Manaus',
      'America/Noronha',
      'America/Porto_Velho',
      'America/Recife',
      'America/Rio_Branco',
      'America/Santarem',
      'America/Sao_Paulo',
    ],
  },
  {
    label: 'Brunei',
    value: 'Brunei',
    timezones: ['Asia/Brunei'],
  },
  {
    label: 'Bulgaria',
    value: 'Bulgaria',
    requiresConsent: true,
    timezones: ['Europe/Sofia'],
  },
  {
    label: 'Cambodia',
    value: 'Cambodia',
    timezones: ['Asia/Phnom_Penh'],
  },
  {
    label: 'Canada',
    value: 'Canada',
    requiresConsent: true,
    isActive: true,
    timezones: [
      'America/Atikokan',
      'America/Blanc-Sablon',
      'America/Cambridge_Bay',
      'America/Creston',
      'America/Dawson',
      'America/Dawson_Creek',
      'America/Edmonton',
      'America/Fort_Nelson',
      'America/Glace_Bay',
      'America/Goose_Bay',
      'America/Halifax',
      'America/Inuvik',
      'America/Iqaluit',
      'America/Moncton',
      'America/Rankin_Inlet',
      'America/Regina',
      'America/Resolute',
      'America/St_Johns',
      'America/Swift_Current',
      'America/Thunder_Bay',
      'America/Toronto',
      'America/Vancouver',
      'America/Whitehorse',
      'America/Winnipeg',
      'America/Yellowknife',
    ],
  },
  {
    label: 'Chile',
    value: 'Chile',
    timezones: [
      'America/Coyhaique',
      'America/Punta_Arenas',
      'America/Santiago',
      'Pacific/Easter',
    ],
  },
  {
    label: 'China',
    value: 'China',
    requiresConsent: true,
    timezones: ['Asia/Macau', 'Asia/Shanghai', 'Asia/Urumqi'],
  },
  {
    label: 'Colombia',
    value: 'Colombia',
    timezones: ['America/Bogota'],
  },
  {
    label: 'Costa Rica',
    value: 'Costa Rica',
    timezones: ['America/Costa_Rica'],
  },
  {
    label: 'Croatia',
    value: 'Croatia',
    requiresConsent: true,
    timezones: ['Europe/Zagreb'],
  },
  {
    label: 'Cyprus',
    value: 'Cyprus',
    requiresConsent: true,
    timezones: ['Asia/Famagusta', 'Asia/Nicosia'],
  },
  {
    label: 'Czech Republic',
    value: 'Czech Republic',
    requiresConsent: true,
    timezones: ['Europe/Prague'],
  },
  {
    label: 'Denmark',
    value: 'Denmark',
    requiresConsent: true,
    timezones: ['Europe/Copenhagen'],
  },
  {
    label: 'Dominican Republic',
    value: 'Dominican Republic',
    timezones: ['America/Santo_Domingo'],
  },
  {
    label: 'Ecuador',
    value: 'Ecuador',
    timezones: ['America/Guayaquil', 'Pacific/Galapagos'],
  },
  {
    label: 'Egypt',
    value: 'Egypt',
    timezones: ['Africa/Cairo'],
  },
  {
    label: 'El Salvador',
    value: 'El Salvador',
    timezones: ['America/El_Salvador'],
  },
  {
    label: 'Estonia',
    value: 'Estonia',
    requiresConsent: true,
    timezones: ['Europe/Tallinn'],
  },
  {
    label: 'Finland',
    value: 'Finland',
    requiresConsent: true,
    timezones: ['Europe/Helsinki'],
  },
  {
    label: 'France',
    value: 'France',
    requiresConsent: true,
    timezones: ['Europe/Paris'],
  },
  {
    label: 'Georgia',
    value: 'Georgia',
    timezones: ['Asia/Tbilisi'],
  },
  {
    label: 'Germany',
    value: 'Germany',
    requiresConsent: true,
    timezones: ['Europe/Berlin'],
  },
  {
    label: 'Greece',
    value: 'Greece',
    requiresConsent: true,
    timezones: ['Europe/Athens'],
  },
  {
    label: 'Grenada',
    value: 'Grenada',
    timezones: ['America/Grenada'],
  },
  {
    label: 'Guatemala',
    value: 'Guatemala',
    timezones: ['America/Guatemala'],
  },
  {
    label: 'Guyana',
    value: 'Guyana',
    timezones: ['America/Guyana'],
  },
  {
    label: 'Haiti',
    value: 'Haiti',
    timezones: ['America/Port-au-Prince'],
  },
  {
    label: 'Honduras',
    value: 'Honduras',
    timezones: ['America/Tegucigalpa'],
  },
  {
    label: 'Hungary',
    value: 'Hungary',
    requiresConsent: true,
    timezones: ['Europe/Budapest'],
  },
  {
    label: 'Iceland',
    value: 'Iceland',
    timezones: ['Atlantic/Reykjavik'],
  },
  {
    label: 'India',
    value: 'India',
    timezones: ['Asia/Kolkata'],
  },
  {
    label: 'Indonesia',
    value: 'Indonesia',
    timezones: [
      'Asia/Jakarta',
      'Asia/Jayapura',
      'Asia/Makassar',
      'Asia/Pontianak',
    ],
  },
  {
    label: 'Ireland',
    value: 'Ireland',
    requiresConsent: true,
    timezones: ['Europe/Dublin'],
  },
  {
    label: 'Israel',
    value: 'Israel',
    timezones: ['Asia/Jerusalem'],
  },
  {
    label: 'Italy',
    value: 'Italy',
    requiresConsent: true,
    timezones: ['Europe/Rome'],
  },
  {
    label: 'Jamaica',
    value: 'Jamaica',
    timezones: ['America/Jamaica'],
  },
  {
    label: 'Japan',
    value: 'Japan',
    requiresConsent: true,
    timezones: ['Asia/Tokyo'],
  },
  {
    label: 'Jordan',
    value: 'Jordan',
    timezones: ['Asia/Amman'],
  },
  {
    label: 'Kazakhstan',
    value: 'Kazakhstan',
    timezones: [
      'Asia/Almaty',
      'Asia/Aqtau',
      'Asia/Aqtobe',
      'Asia/Atyrau',
      'Asia/Oral',
      'Asia/Qostanay',
      'Asia/Qyzylorda',
    ],
  },
  {
    label: 'Kenya',
    value: 'Kenya',
    timezones: ['Africa/Nairobi'],
  },
  {
    label: 'Kuwait',
    value: 'Kuwait',
    timezones: ['Asia/Kuwait'],
  },
  {
    label: 'Kyrgyzstan',
    value: 'Kyrgyzstan',
    timezones: ['Asia/Bishkek'],
  },
  {
    label: 'Laos',
    value: 'Laos',
    timezones: ['Asia/Vientiane'],
  },
  {
    label: 'Latvia',
    value: 'Latvia',
    requiresConsent: true,
    timezones: ['Europe/Riga'],
  },
  {
    label: 'Lebanon',
    value: 'Lebanon',
    timezones: ['Asia/Beirut'],
  },
  {
    label: 'Liechtenstein',
    value: 'Liechtenstein',
    timezones: ['Europe/Vaduz'],
  },
  {
    label: 'Lithuania',
    value: 'Lithuania',
    requiresConsent: true,
    timezones: ['Europe/Vilnius'],
  },
  {
    label: 'Luxembourg',
    value: 'Luxembourg',
    requiresConsent: true,
    timezones: ['Europe/Luxembourg'],
  },
  {
    label: 'Malaysia',
    value: 'Malaysia',
    timezones: ['Asia/Kuala_Lumpur', 'Asia/Kuching'],
  },
  {
    label: 'Maldives',
    value: 'Maldives',
    timezones: ['Indian/Maldives'],
  },
  {
    label: 'Malta',
    value: 'Malta',
    requiresConsent: true,
    timezones: ['Europe/Malta'],
  },
  {
    label: 'Mexico',
    value: 'Mexico',
    timezones: [
      'America/Bahia_Banderas',
      'America/Cancun',
      'America/Chihuahua',
      'America/Ciudad_Juarez',
      'America/Hermosillo',
      'America/Matamoros',
      'America/Mazatlan',
      'America/Merida',
      'America/Mexico_City',
      'America/Monterrey',
      'America/Ojinaga',
      'America/Tijuana',
    ],
  },
  {
    label: 'Mongolia',
    value: 'Mongolia',
    timezones: [
      'Asia/Hovd',
      'Asia/Ulaanbaatar', // Asia/Choibalsan became an alias for Asia/Ulaanbaatar in tzdata 2024b
    ],
  },
  {
    label: 'Morocco',
    value: 'Morocco',
    requiresConsent: true,
    timezones: ['Africa/Casablanca', 'Africa/El_Aaiun'],
  },
  {
    label: 'Myanmar',
    value: 'Myanmar',
    timezones: ['Asia/Yangon'],
  },
  {
    label: 'Nepal',
    value: 'Nepal',
    timezones: ['Asia/Kathmandu'],
  },
  {
    label: 'Netherlands',
    value: 'Netherlands',
    requiresConsent: true,
    isActive: true,
    timezones: ['Europe/Amsterdam'],
  },
  {
    label: 'New Zealand',
    value: 'New Zealand',
    requiresConsent: true,
    timezones: ['Pacific/Auckland', 'Pacific/Chatham'],
  },
  {
    label: 'Nicaragua',
    value: 'Nicaragua',
    timezones: ['America/Managua'],
  },
  {
    label: 'Nigeria',
    value: 'Nigeria',
    timezones: ['Africa/Lagos'],
  },
  {
    label: 'Norway',
    value: 'Norway',
    requiresConsent: true,
    timezones: ['Europe/Oslo'],
  },
  {
    label: 'Oman',
    value: 'Oman',
    timezones: ['Asia/Muscat'],
  },
  {
    label: 'Pakistan',
    value: 'Pakistan',
    timezones: ['Asia/Karachi'],
  },
  {
    label: 'Palestine',
    value: 'Palestine',
    timezones: ['Asia/Gaza', 'Asia/Hebron'],
  },
  {
    label: 'Panama',
    value: 'Panama',
    timezones: ['America/Panama'],
  },
  {
    label: 'Paraguay',
    value: 'Paraguay',
    timezones: ['America/Asuncion'],
  },
  {
    label: 'Peru',
    value: 'Peru',
    timezones: ['America/Lima'],
  },
  {
    label: 'Philippines',
    value: 'Philippines',
    timezones: ['Asia/Manila'],
  },
  {
    label: 'Poland',
    value: 'Poland',
    requiresConsent: true,
    timezones: ['Europe/Warsaw'],
  },
  {
    label: 'Portugal',
    value: 'Portugal',
    requiresConsent: true,
    timezones: ['Atlantic/Azores', 'Atlantic/Madeira', 'Europe/Lisbon'],
  },
  {
    label: 'Qatar',
    value: 'Qatar',
    timezones: ['Asia/Qatar'],
  },
  {
    label: 'Romania',
    value: 'Romania',
    requiresConsent: true,
    timezones: ['Europe/Bucharest'],
  },
  {
    label: 'Russia',
    value: 'Russia',
    requiresConsent: true,
    timezones: [
      // Europe/Simferopol (Crimea) is intentionally omitted. IANA lists it
      // as both RU and UA, reflecting the disputed status of Crimea.
      // We omit it rather than assign it to either country.
      'Asia/Anadyr',
      'Asia/Barnaul',
      'Asia/Chita',
      'Asia/Irkutsk',
      'Asia/Kamchatka',
      'Asia/Khandyga',
      'Asia/Krasnoyarsk',
      'Asia/Magadan',
      'Asia/Novokuznetsk',
      'Asia/Novosibirsk',
      'Asia/Omsk',
      'Asia/Sakhalin',
      'Asia/Srednekolymsk',
      'Asia/Tomsk',
      'Asia/Ust-Nera',
      'Asia/Vladivostok',
      'Asia/Yakutsk',
      'Asia/Yekaterinburg',
      'Europe/Astrakhan',
      'Europe/Kaliningrad',
      'Europe/Kirov',
      'Europe/Moscow',
      'Europe/Samara',
      'Europe/Saratov',
      'Europe/Ulyanovsk',
      'Europe/Volgograd',
    ],
  },
  {
    label: 'Rwanda',
    value: 'Rwanda',
    timezones: ['Africa/Kigali'],
  },
  {
    label: 'Saint Kitts and Nevis',
    value: 'Saint Kitts and Nevis',
    timezones: ['America/St_Kitts'],
  },
  {
    label: 'Saint Lucia',
    value: 'Saint Lucia',
    timezones: ['America/St_Lucia'],
  },
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'Saint Vincent and the Grenadines',
    timezones: ['America/St_Vincent'],
  },
  {
    label: 'Saudi Arabia',
    value: 'Saudi Arabia',
    timezones: ['Asia/Riyadh'],
  },
  {
    label: 'Singapore',
    value: 'Singapore',
    timezones: ['Asia/Singapore'],
  },
  {
    label: 'Slovakia',
    value: 'Slovakia',
    requiresConsent: true,
    timezones: ['Europe/Bratislava'],
  },
  {
    label: 'Slovenia',
    value: 'Slovenia',
    requiresConsent: true,
    timezones: ['Europe/Ljubljana'],
  },
  {
    label: 'South Africa',
    value: 'South Africa',
    requiresConsent: true,
    timezones: ['Africa/Johannesburg'],
  },
  {
    label: 'South America (Region)',
    value: 'South America (Region)',
    timezones: ['America/Caracas', 'America/Cayenne', 'Atlantic/Stanley'],
  },
  {
    label: 'South Korea',
    value: 'South Korea',
    requiresConsent: true,
    timezones: ['Asia/Seoul'],
  },
  {
    label: 'Spain',
    value: 'Spain',
    requiresConsent: true,
    timezones: ['Africa/Ceuta', 'Atlantic/Canary', 'Europe/Madrid'],
  },
  {
    label: 'Sri Lanka',
    value: 'Sri Lanka',
    timezones: ['Asia/Colombo'],
  },
  {
    label: 'Suriname',
    value: 'Suriname',
    timezones: ['America/Paramaribo'],
  },
  {
    label: 'Sweden',
    value: 'Sweden',
    requiresConsent: true,
    timezones: ['Europe/Stockholm'],
  },
  {
    label: 'Switzerland',
    value: 'Switzerland',
    requiresConsent: true,
    timezones: ['Europe/Zurich'],
  },
  {
    label: 'Taiwan',
    value: 'Taiwan',
    timezones: ['Asia/Taipei'],
  },
  {
    label: 'Tajikistan',
    value: 'Tajikistan',
    timezones: ['Asia/Dushanbe'],
  },
  {
    label: 'Thailand',
    value: 'Thailand',
    timezones: ['Asia/Bangkok'],
  },
  {
    label: 'Timor-Leste',
    value: 'Timor-Leste',
    timezones: ['Asia/Dili'],
  },
  {
    label: 'Trinidad and Tobago',
    value: 'Trinidad and Tobago',
    timezones: ['America/Port_of_Spain'],
  },
  {
    label: 'Tunisia',
    value: 'Tunisia',
    timezones: ['Africa/Tunis'],
  },
  {
    label: 'Turkey',
    value: 'Turkey',
    timezones: ['Europe/Istanbul'],
  },
  {
    label: 'Turkmenistan',
    value: 'Turkmenistan',
    timezones: ['Asia/Ashgabat'],
  },
  {
    label: 'Uganda',
    value: 'Uganda',
    timezones: ['Africa/Kampala'],
  },
  {
    label: 'Ukraine',
    value: 'Ukraine',
    requiresConsent: true,
    timezones: ['Europe/Kyiv'],
  },
  {
    label: 'United Arab Emirates',
    value: 'United Arab Emirates',
    timezones: ['Asia/Dubai'],
  },
  {
    label: 'United Kingdom',
    value: 'United Kingdom',
    requiresConsent: true,
    isActive: true,
    timezones: ['Europe/London'],
  },
  {
    label: 'United States',
    value: 'United States',
    isActive: true,
    timezones: [
      'America/Adak',
      'America/Anchorage',
      'America/Boise',
      'America/Chicago',
      'America/Denver',
      'America/Detroit',
      'America/Indiana/Indianapolis',
      'America/Indiana/Knox',
      'America/Indiana/Marengo',
      'America/Indiana/Petersburg',
      'America/Indiana/Tell_City',
      'America/Indiana/Vevay',
      'America/Indiana/Vincennes',
      'America/Indiana/Winamac',
      'America/Juneau',
      'America/Kentucky/Louisville',
      'America/Kentucky/Monticello',
      'America/Los_Angeles',
      'America/Menominee',
      'America/Metlakatla',
      'America/New_York',
      'America/Nome',
      'America/North_Dakota/Beulah',
      'America/North_Dakota/Center',
      'America/North_Dakota/New_Salem',
      'America/Phoenix',
      'America/Puerto_Rico',
      'America/Sitka',
      'America/Yakutat',
      'Pacific/Guam',
      'Pacific/Honolulu',
      'Pacific/Pago_Pago',
      'Pacific/Saipan',
    ],
  },
  {
    label: 'Uruguay',
    value: 'Uruguay',
    timezones: ['America/Montevideo'],
  },
  {
    label: 'Uzbekistan',
    value: 'Uzbekistan',
    timezones: ['Asia/Samarkand', 'Asia/Tashkent'],
  },
  {
    label: 'Vietnam',
    value: 'Vietnam',
    requiresConsent: true,
    timezones: ['Asia/Ho_Chi_Minh'],
  },
  {
    label: 'Yemen',
    value: 'Yemen',
    timezones: ['Asia/Aden'],
  },
  {
    label: 'Zambia',
    value: 'Zambia',
    timezones: ['Africa/Lusaka'],
  },
];
